module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0152.jpg?v=9f2fbce2";